export class Alert {
    /**
     * Create a new Alert instance
     */
    constructor() {
        this.message = "";
    }

    /**
     * Determine if we have any errors.
     *
     * @returns {boolean}
     */
    any() {
        return this.message !== "";
    }

    /**
     * Retrieve the error message for a field.
     */
    get() {
        return this.message;
    }

    /**
     * Set the new errors
     *
     * @param {string} message
     */
    set(message) {
        this.message = message;
    }

    /**
     * Clear one or all error fields.
     */
    clear() {
        this.set("");
    }
}